const payment = require('./payment');
const message = require('./message');
const shipping = require('./shipping');
const customer = require('./customer');
const lineItem = require('./line-item');
const orderTotals = require('./order-totals');
const adr = require('./adr');

module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        id: {
            type: 'string'
        },
        cartCreatedAt: {
            type: 'string'
        },
        lastModifiedAt: {
            type: 'string'
        },
        lineItems: {
            type: 'array',
            items: lineItem
        },
        type: {
            type: ['string', 'null']
        },
        category: {
            type: 'string'
        },
        channel: {
            type: ['string', 'null']
        },
        shipping: shipping,
        customer: customer,
        action: {
            type: 'string'
        },
        soldToMemberId: {
            type: 'string'
        },
        orderId: {
            type: 'string'
        },
        adr: {
            type: ['object', 'null'],
            items: adr
        },
        countryCode: {
            type: 'string'
        },
        salesOffice: {
            type: 'string'
        },
        date: {
            type: ['string', 'number']
        },
        dateCancelled: {
            type: ['string', 'null']
        },
        dateReturned: {
            type: ['string', 'null']
        },
        productDiscountCode: {
            type: 'string'
        },
        shippingDiscountCode: {
            type: 'string'
        },
        commissionableInPriorMonth: {
            type: 'boolean'
        },
        commissionedInPriorMonth: {
            type: 'boolean'
        },
        reason: {
            type: 'string'
        },
        currencyCode: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        externalId: {
            type: 'string'
        },
        giftReceipt: {
            type: 'boolean'
        },
        serialNumber: {
            type: ['string', 'null']
        },
        messages: {
            type: 'array',
            items: message
        },
        timeStamp: {
            type: ['string', 'null']
        },
        orderProcessingState: {
            type: ['string', 'null']
        },
        redirectUrl: {
            type: ['string', 'null']
        },
        payments: {
            type: 'array',
            items: payment
        },
        pricing: {
            type: ['array', 'null']
        },
        orderTotals: {
            type: ['object', 'null'],
            items: orderTotals
        },
        sender: {
            type: ['string', 'null']
        },
        shippingPayWithPoints: {
            type: ['string', 'null']
        },
        eventCode: {
            type: ['string', 'null']
        },
        microsite: {
            type: ['string', 'null']
        }
    }
};
